import { Component } from '@angular/core';

@Component({
  selector: 'app-absence-planner',
  templateUrl: './absence-planner.component.html',
  standalone: false,
})
export class AbsencePlannerComponent {}
